// extracted by mini-css-extract-plugin
export default {"container":"BadgeCard_container__aaGOd","image":"BadgeCard_image__A9dbO","title":"BadgeCard_title__vREnc"};